import { Box, Button, Chip, Card, Grid, Popover, RadioGroup, FormControlLabel, Radio, IconButton, Typography, Tooltip, MenuItem, TextField, FormControl, Select, Paper, InputAdornment, Badge, Pagination } from '@mui/material'
import { DataGrid, getGridStringOperators, gridPageCountSelector, gridPageSelector, GridPagination, useGridApiContext, useGridSelector } from '@mui/x-data-grid'

const CustomPagination = () => {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    const handlePageChange = (event, value) => {
        apiRef.current.setPage(value - 1); // MUI Pagination uses 1-based indexing, DataGrid uses 0-based
    };

    return (
        <Grid container sx={{
            // display: 'flex',
            // // flexDirection: { xs: 'column', sm: 'row' },
            // justifyContent: 'space-between',
            // alignItems: 'center',
            padding: '8px 16px',
            borderTop: '1px solid rgba(224, 224, 224, 1)'
        }}>
            <Grid xs={6} sm={1} md={4} sx={{display:{xs:'none',sm:'block'}}} />
            {/* Page size selector (optional) */}
            <Grid item xs={12} sm={5} md={4} sx={{ display: 'flex', alignItems: 'center',justifyContent:'center', gap: 1 }}>
                <Typography variant="body2" color="text.secondary">
                    Rows Per Page:
                </Typography>
                <TextField
                    select
                    size="small"
                    value={apiRef.current.state.pagination.paginationModel.pageSize}
                    onChange={(e) => {
                        apiRef.current.setPageSize(Number(e.target.value));
                    }}
                    sx={{
                        minWidth: 70,
                        '& .MuiInputBase-input': {
                            fontSize: '0.875rem',
                            padding: '4px 8px'
                        }
                    }}
                >
                    {[5, 10, 20, 50, 100].map((size) => (
                        <MenuItem key={size} value={size}>
                            {size}
                        </MenuItem>
                    ))}
                </TextField>
                <Typography variant="body2" color="text.secondary">
                    {((page) * apiRef.current.state.pagination.paginationModel.pageSize) + 1}-
                    {Math.min((page + 1) * apiRef.current.state.pagination.paginationModel.pageSize,
                        apiRef.current.state.pagination.rowCount)} of {apiRef.current.state.pagination.rowCount}
                </Typography>
            </Grid>

            {/*  Rows per page info */}
            {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="body2" color="text.secondary">
                    Rows per page: {apiRef.current.state.pagination.paginationModel.pageSize}
                </Typography>
                
            </Box> */}



            {/*  Page numbers  */}
            <Grid item xs={12} sm={6} md={4} sx={{ display: 'flex', justifyContent: 'center', mt:{xs:'1%',md:0}}}>
                <Pagination
                    count={pageCount}
                    page={page + 1} // Convert from 0-based to 1-based
                    onChange={handlePageChange}
                    variant="outlined"
                    shape="rounded"
                    size="small"
                    // showFirstButton
                    // showLastButton
                    sx={{
                        '& .MuiPaginationItem-root': {
                            fontSize: '0.875rem',
                            fontWeight: 500,
                        },
                        '& .Mui-selected': {
                            backgroundColor: 'primary.main',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: 'primary.dark',
                            }
                        }
                    }}
                />
            </Grid>

        </Grid>
    );
};


export default CustomPagination